declare var _gaq: any;

export class Accordion {

    private accordionId: number = -1;
    private accordionSelector: string = "";
    private affectsURL: boolean = true;

    constructor(accordionId?: number, affectsURL?: boolean) {
        if (accordionId > -1) {
            this.accordionId = accordionId;          
        } else {
            this.accordionId = 0;
        }

        this.accordionSelector = `[data-offer-accordion="${this.accordionId}"]`;

        if (typeof affectsURL !== "undefined") {
            this.affectsURL = affectsURL;
        }

        const headerSelector = `${this.accordionSelector} [data-offer-heading]`;
        const headers: NodeListOf<HTMLElement> = document.querySelectorAll(headerSelector) as NodeListOf<HTMLElement>;

        if (headers) {
            this.BindAccordionUIFunctionality();
            if (this.affectsURL) {
                this.CheckURL();

                window.onpopstate = () => {
                    window.history.go(-1);
                };
            }
        }
    }

    private BindAccordionUIFunctionality() {
        const headerSelector = `${this.accordionSelector} [data-offer-heading]`;
        const headers: NodeListOf<HTMLElement> = document.querySelectorAll(headerSelector) as NodeListOf<HTMLElement>;
        
        for (let i = 0; i < headers.length; i++) {
            headers[i].addEventListener("click", () => {
                const id: string = headers[i].getAttribute("data-offer-heading");
                for (let j = 0; j < headers.length; j++) {
                    if (headers[j].getAttribute("data-offer-heading") === id && headers[j].getAttribute("data-is-active") === "false") {
                        this.ActivateOffer(id);
                    } else {
                        this.DeactivateOffer(headers[j].getAttribute("data-offer-heading"));
                    }
                }   
                _gaq.push(["_trackEvent", "Interaction", `Accordion Interaction (${id})`, document.URL, 0, false]);             
            });
        }
    }

    private ActivateOffer(offerId: string) {
        const header: HTMLElement = document.querySelector(`${this.accordionSelector} [data-offer-heading="${offerId}"]`) as HTMLElement;
        const content: HTMLElement = document.querySelector(`${this.accordionSelector} [data-offer-content="${offerId}"]`) as HTMLElement;
        let height: number;
        let tmt: any = {};
        let tmt2: any = {};

        content.style.height = "auto";
        height = content.clientHeight + 24;
        content.style.height = "0";
        content.classList.add("animatingIn");

        clearTimeout(tmt);
        clearTimeout(tmt2);

        tmt = setTimeout(() => {
            content.style.opacity = "1";
            content.style.paddingTop = "12px";
            content.style.paddingBottom = "12px";
            content.style.height = `${height}px`;

            header.setAttribute("data-is-active", "true");
        }, 1);

        tmt2 = setTimeout(() => {
            content.style.height = "auto";
        }, 601);

        if (this.affectsURL) {
            window.history.pushState({}, "", `${this.GetCleanURL()}#${offerId}`);
        }
    }

    private DeactivateOffer(offerId: string) {
        const header: HTMLElement = document.querySelector(`${this.accordionSelector} [data-offer-heading="${offerId}"]`) as HTMLElement;
        const content: HTMLElement = document.querySelector(`${this.accordionSelector} [data-offer-content="${offerId}"]`) as HTMLElement;
        let height: number;
        let tmt: any = {};
        let tmt2: any = {};

        content.classList.remove("animatingIn");
        content.classList.add("animatingOut");

        height = content.clientHeight + 24;
        content.style.height = `${height}px`;

        clearTimeout(tmt);
        clearTimeout(tmt2);

        tmt = setTimeout(() => {
            content.style.opacity = "0";
            content.style.paddingTop = "0px";
            content.style.paddingBottom = "0px";
            content.style.height = "0px";
        }, 1);

        tmt2 = setTimeout(() => {
            content.classList.remove("animatingOut");
            content.removeAttribute("style");

            header.setAttribute("data-is-active", "false");
        }, 600);

        if (this.affectsURL) {
            if (this.GetOfferFromURL() === offerId) {
                window.history.pushState({}, "", this.GetCleanURL());
            }
        }
    }

    private CheckURL() {
        const headerSelector = `${this.accordionSelector} [data-offer-heading]`;
        const headers: NodeListOf<HTMLElement> = document.querySelectorAll(headerSelector) as NodeListOf<HTMLElement>;
        const url: string = document.URL;
        let urlLimit: number = 0;
        let id: string = "";

        if (url.indexOf("?") > - 1) {
            urlLimit = url.indexOf("?");
        } else {
            urlLimit = url.length;
        }

        if (url.indexOf("#")) {
            id = url.substring(url.indexOf("#") + 1, urlLimit);
            for (let j = 0; j < headers.length; j++) {
                if (headers[j].getAttribute("data-offer-heading") === id && headers[j].getAttribute("data-is-active") === "false") {
                    this.ActivateOffer(id);
                } else {
                    this.DeactivateOffer(headers[j].getAttribute("data-offer-heading"));
                }
            }
        }
    }

    private GetCleanURL(): string {
        const url: string = document.URL;
        return url.substring(0, url.lastIndexOf("/") + 1);
    }

    private GetOfferFromURL(): string {
        const url: string = document.URL;
        let id: string = "";
        let urlLimit: number = 0;

        if (url.indexOf("?") > - 1) {
            urlLimit = url.indexOf("?");
        } else {
            urlLimit = url.length;
        }

        if (url.indexOf("#")) {
            id = url.substring(url.indexOf("#") + 7, urlLimit);
        }

        return id;
    }

}



// WEBPACK FOOTER //
// ./src/global/Accordion.ts